module.exports = __webpack_public_path__ + "static/avatar_leisan_utyasheva@2x-5bbdaf9805cf8219bfb1443f83304508.jpg";